import React, { useState, useEffect, useCallback } from 'react';
import webPush from '../../lib/web_push_notifications';

/**
 * メッセージ一覧の上に出す「デスクトップ通知を受け取る」案内（TGW-3137）。
 * 出す条件（lib/web_push_notifications.js#shouldShowBanner）: 対応ブラウザ・未許可・購読していない・30日以内に閉じていない。
 * サーバ側は web_push_available?（設定あり・ログイン中・アプリ内 WebView ではない）のときだけこの部品を描く。
 */
const styles = {
  wrap: { maxWidth: 672, margin: '12px auto 0', padding: '0 16px' },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 16px',
    background: '#FFFFFF',
    border: '1px solid #D3D3D8',
    borderRadius: 16,
  },
  body: { flex: 1, minWidth: 0 },
  title: { margin: 0, fontSize: 14, fontWeight: 700, lineHeight: 1.5, color: '#4A4A52' },
  note: { margin: '2px 0 0', fontSize: 11, lineHeight: 1.4, color: '#8A8A93' },
  actions: { display: 'flex', gap: 8, flexShrink: 0 },
  primary: {
    padding: '8px 14px',
    border: 0,
    borderRadius: 8,
    background: '#FF6467',
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  },
  secondary: {
    padding: '8px 10px',
    border: 0,
    borderRadius: 8,
    background: 'transparent',
    color: '#8A8A93',
    fontSize: 13,
    cursor: 'pointer',
  },
};

const WebPushPromptBanner = () => {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setVisible(webPush.shouldShowBanner());
    return webPush.onChange((current) => setVisible(webPush.shouldShowBanner(current)));
  }, []);

  const onAllow = useCallback(async () => {
    setBusy(true);
    try {
      await webPush.subscribe();
    } catch (e) {
      // 失敗しても画面は壊さない。案内は shouldShowBanner の判定に従って残る/消える
    } finally {
      setBusy(false);
    }
  }, []);

  const onDismiss = useCallback(() => webPush.dismissBanner(), []);

  if (!visible) return null;

  return (
    <div style={styles.wrap} data-testid="web-push-prompt-banner">
      <div style={styles.card} role="region" aria-label="デスクトップ通知の案内">
        <div style={styles.body}>
          <p style={styles.title}>新着メッセージをデスクトップ通知で受け取る</p>
          <p style={styles.note}>このブラウザを開いていなくても、アプリと同じお知らせが届きます</p>
        </div>
        <div style={styles.actions}>
          <button type="button" style={styles.primary} onClick={onAllow} disabled={busy}>
            {busy ? '設定中…' : '許可する'}
          </button>
          <button type="button" style={styles.secondary} onClick={onDismiss} disabled={busy}>
            あとで
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebPushPromptBanner;
